var t = /* @__PURE__ */ ((e) => (e.medium = "medium", e.large = "large", e))(t || {}), l = /* @__PURE__ */ ((e) => (e.numbered = "numbered", e.bullet = "bullet", e))(l || {}), n = /* @__PURE__ */ ((e) => (e.vertical = "vertical", e.horizontal = "horizontal", e))(n || {});
const o = Symbol("stepper");
function a(e) {
  const r = ["stepper"];
  return e.spacing === "large" && r.push("stepper-large"), e.orientation === "horizontal" && r.push("stepper-horizontal"), r.join(" ");
}
export {
  l as EStepperIndicatorTypes,
  n as EStepperOrientations,
  t as EStepperSpacings,
  o as StepperSymbol,
  a as getStepperConditionalClasses
};
